export const roundTo = (val: number, n: number): number => {
  const lower = Math.floor(val / n) * n;
  const upper = lower + n;
  return Math.abs(val - lower) < Math.abs(val - upper) ? lower : upper;
};
